import React from 'react';

export const TERMS_URL = 'https://www.bilderit.com/es/terms';
export const PRIVACY_POLICY_URL = 'https://www.bilderit.com/es/privacy';

const ExternalLegalLink: React.FC<{
  href: string;
  children?: React.ReactNode;
}> = ({ href, children }) => (
  <a
    href={href}
    rel="noreferrer"
    target="_blank"
    className="underline underline-offset-4"
  >
    {children}
  </a>
);

export const TermsLink: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => <ExternalLegalLink href={TERMS_URL}>{children}</ExternalLegalLink>;

export const PrivacyPolicyLink: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => (
  <ExternalLegalLink href={PRIVACY_POLICY_URL}>{children}</ExternalLegalLink>
);
